import React, { useEffect, useMemo } from 'react';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import type { ComponentRuntimeProps } from '@atlassian/jira-ai-rovo-panel/src/ui/types.tsx';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { aiRovoPanelEntryPoint } from '@atlassian/jira-ai-rovo-panel/src/entrypoint.tsx';

const entrypointParams = {};

export const AsyncAiRovoPanel = (props: ComponentRuntimeProps) => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		aiRovoPanelEntryPoint,
		entrypointParams,
	);

	// TODO (RVRY-42) Avoid deprecated useEntryPoint and loading entrypoint in hooks
	/*
		Handle the loading of the panel module when the button clicked / side panel opened.
		The preload has already been done as part of the trigger AiRovoButton
	*/
	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		entryPointActions.load();
	}, [entryPointActions]);

	const { onClosePanel } = props;
	const runtimeProps = useMemo(() => ({ onClosePanel }), [onClosePanel]);

	return (
		<JiraEntryPointContainer
			entryPointReferenceSubject={entryPointReferenceSubject}
			id="jiraAiRovoPanelEntryPoint"
			packageName="jira-ai-rovo-panel"
			teamName="reverie-ai"
			fallback={null}
			runtimeProps={runtimeProps}
		/>
	);
};
